<template>
  <div>
    <div
      v-if="!filteredResources || Object.keys(filteredResources).length === 0"
    >
      <div
        v-for="(resource, i) in allResources"
        :ref="resource.slug"
        :key="i"
        class="mx-auto mt-[40px] w-[100vw] max-w-[856px] pl-6 lg:pl-0"
      >
        <h1
          class="mb-[16px] font-aktiv-grotesk text-[24px] leading-[32px] font-bold"
        >
          {{ resource.name }}
        </h1>
        <ResourcesSlider
          :category="resource.name"
          :tag-slug="resource.slug"
          :category-index="i"
          :items="resource.resources"
        />
      </div>
    </div>
    <div v-else class="mx-auto mt-[40px] w-[100vw] max-w-[856px] pl-6 lg:pl-0">
      <FilterResultSection :filteredResources="filteredResources" />
    </div>
    <div class="mx-auto mt-[40px] w-[100vw] max-w-[856px] pl-6 lg:pl-0">
      <h1
        class="mb-[16px] font-aktiv-grotesk text-[24px] leading-[32px] font-bold"
      >
        {{ bookName }}
      </h1>
      <div class="rounded-[16px] w-[228px] md:w-[262px] md:pr-6 lg:w-[287px]">
        <in-app-browser
          :href="bookUrl"
          target="_blank"
          data-event-tracking="book-generations-volume-1"
        >
          <img
            class="w-full rounded-[16px] cursor-pointer"
            :src="bookThumbnailUrl"
          />
        </in-app-browser>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ResourcesSlider from "@/components/ResourcesPage/PlaybackResources/ResourcesSlider.vue";
import FilterResultSection from "@/components/ResourcesPage/PlaybackResources/FilterResultSection.vue";

export default {
  components: {
    ResourcesSlider,
    FilterResultSection,
  },
  computed: {
    ...mapState("filter", [
      "allResources",
      "allQuotes",
      "allBooks",
      "isLoading",
      "filteredResources",
    ]),
    bookUrl() {
      if (this.allBooks && this.allBooks.length > 0) {
        return this.allBooks[0].resources[0].resourceTranslations[0]
          .resourceUrl;
      }
      return "";
    },
    bookThumbnailUrl() {
      if (this.allBooks && this.allBooks.length > 0) {
        return this.allBooks[0].resources[0].thumbnail;
      }
      return "";
    },
    bookName() {
      if (this.allBooks && this.allBooks.length > 0) {
        return this.allBooks[0].name;
      }
      return "";
    },
  },
};
</script>
